<template>
  <!-- begin #footer -->
  <div id="footer" class="fixed pull-right">
    <strong>
      &copy; 2019 电子商城后台管理系统
      <span class="m-l-20">{{helloMessage}}</span>
    </strong>
  </div>

  <!-- end #footer -->
</template>

<script>
import PageOptions from "../../config/PageOptions.vue";
import moment from "moment";
export default {
  name: "Footer",
  data() {
    return {
      pageOptions: PageOptions,
      helloMessage: "",
      timer: null
    };
  },
  created() {
    moment.locale("zh-cn");
    let _this = this;
    this.timer = setInterval(function() {
      _this.helloMessage = moment().format("YYYY年MM月DD日 HH:mm:ss");
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style>
.fixed {
  position: fixed;
  bottom: 0px;
  margin-right: 0px;
  width: 100%;
  z-index: -1;
  padding: 10px 0;
  margin: 0 30px 0 250px;
  border-top: 1px solid #cad0d6;
  line-height: 20px;
}
</style>